/**
 * Use these filters to format currency values.
 *
 * Currently defers to the cash extension although the currency handling could
 * benefit from some thought and reworking.
 *
 * Usage Examples:
 *
 *      {{ 1234.567 | € }}     // €1,234.56
 *      {{ 1234 | € }}         // €1,234
 *
 *      {{ 1234 | € | 0s }}    // €1,234.00
 */
define('common/ko/filters/currencyFilter',['underscore', 'knockout', 'knockout.punches'], function (_, ko) {

    ko.filters['€'] = function (wrappedValue) {

        var value = ko.unwrap(wrappedValue);

        if (!value && value !== 0) {
            return '';
        }

        var computed = ko.computed(function() {
                return _.floor(value, 2);
            }).extend({cash: true}),
            result;

        result = computed.formattedCash();

        computed.dispose();

        return result.replace('.00', '');
    };

    ko.filters['0s'] = function (wrappedValue) {

        var value = ko.unwrap(wrappedValue);

        if (value === '' || value.substr(-3, 1) === '.') {
            return value;
        }

        return value + '.00';

    };

});

